import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import SignedImage from '../../SignedImage/SignedImage';

const ChatHeader = ({
  otherUserInfo,
  otherUserLoading,
  profileImageUrl,
  isEmployee,
  isApplicantConversation,
  conversationData,
  restaurantUserId,
  employeeId,
  conversationId,
  connectionStatus,
  tokenError,
  onScheduleCallClick,
  onHireClick,
  hiringData
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const isHired = hiringData?.status === 'accepted' || hiringData?.status === 'active';
  const isOfferPending = hiringData?.status === 'offered';
  const canHire = !isEmployee && onHireClick && !isOfferPending && !isHired;
  const canScheduleCall = Boolean(conversationId && onScheduleCallClick);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    if (menuOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  const handleMenuAction = (fn) => {
    if (typeof fn === 'function') fn();
    setMenuOpen(false);
  };

  return (
    <div className="chat__header">
      <div className="chat__header-user-info">
        {otherUserInfo ? (
          <>
            <div className="chat__header-avatar">
              <SignedImage
                src={profileImageUrl}
                alt={isEmployee 
                  ? (isApplicantConversation 
                      ? (otherUserInfo?.headerData?.name || 'Restaurant')
                      : (otherUserInfo?.name || 'Restaurant')
                    )
                  : (otherUserInfo?.name || 'Employee')
                }
                fallbackSrc="/default-avatar.png"
                showLoading={true}
                className="chat__avatar-image"
                onLoad={() => {
                  // Image loaded successfully
                }}
                onError={() => {
                  // Image failed to load, using fallback
                }}
              />
            </div>
            <div className="chat__header-details">
              <h3 className="chat__header-name">
                {isEmployee 
                  ? (isApplicantConversation 
                      ? otherUserInfo?.headerData?.position || 'Job Position'
                      : otherUserInfo?.restaurantName || otherUserInfo?.name || 'Restaurant'
                    )
                  : (otherUserInfo?.name || 'Employee') + ' ' + (otherUserInfo?.surname || '')
                }
              </h3>
              <p className="chat__header-position">
                {isEmployee 
                  ? (isApplicantConversation 
                      ? otherUserInfo?.headerData?.name || 'Restaurant'
                      : otherUserInfo?.position || 'Position'
                    )
                  : (isApplicantConversation 
                      ? otherUserInfo?.position || 'Position'
                      : otherUserInfo?.position || 'Position'
                    )
                }
              </p>
            </div>
          </>
        ) : (
          <div className="chat__header-loading">
            <h3>
              {otherUserLoading 
                ? (isEmployee 
                    ? (isApplicantConversation ? 'Loading job info...' : 'Loading restaurant info...')
                    : 'Loading employee info...'
                  ) 
                : (isEmployee 
                    ? (isApplicantConversation ? 'Job info not available' : 'Restaurant info not available')
                    : 'Employee info not available'
                  )
              }
            </h3>
            {!otherUserLoading && (
              <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.5rem' }}>
                {isEmployee 
                  ? (isApplicantConversation 
                      ? `Job ID: ${conversationData?.jobOfferId || 'Not found'}`
                      : `Restaurant ID: ${restaurantUserId}`
                    )
                  : `Employee ID: ${employeeId}`
                }
              </p>
            )}
          </div>
        )}
      </div>
      <div className="chat__header-actions">
        {(canHire || canScheduleCall) && (
          <div className="chat__header-menu" ref={menuRef}>
            <button
              type="button"
              className="chat__header-menu-trigger"
              onClick={() => setMenuOpen((o) => !o)}
              aria-label="Más opciones"
              aria-expanded={menuOpen}
            >
              <FontAwesomeIcon icon={faEllipsis} />
            </button>
            {menuOpen && (
              <div className="chat__header-menu-dropdown">
                {canScheduleCall && (
                  <button
                    type="button"
                    className="chat__header-menu-item"
                    onClick={() => handleMenuAction(onScheduleCallClick)}
                  >
                    Programar llamada
                  </button>
                )}
                {!isEmployee && (
                  <button
                    type="button"
                    className={`chat__header-menu-item ${isOfferPending ? 'chat__header-menu-item--offered' : ''} ${isHired ? 'chat__header-menu-item--hired' : ''}`}
                    onClick={() => canHire && handleMenuAction(onHireClick)}
                    disabled={!canHire}
                  >
                    {isOfferPending ? 'Oferta Enviada' : isHired ? 'Contratado' : 'Contratar'}
                  </button>
                )}
              </div>
            )}
          </div>
        )}
        <div className="chat__header-status">
          <div className={`connection-status ${connectionStatus}`}>
            <span className="status-dot"></span>
            {connectionStatus === 'connected' ? '' : 
             connectionStatus === 'disconnected' ? '' : 
             connectionStatus === 'error' ? 'ERROR' : connectionStatus}
          </div>
          {tokenError && (
            <div style={{ 
              fontSize: '0.75rem', 
              color: '#f44336', 
              marginTop: '4px',
              maxWidth: '200px',
              wordWrap: 'break-word'
            }}>
              {tokenError}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;

